import { useDispatch, useSelector } from "react-redux";
import { useLegacyEffect } from "helper/customHook";
// import { ReactComponent as IconCamera } from "assets/svg/20-camera.svg";
import { ReactComponent as IconBell } from "assets/svg/20-bell.svg";
import { ReactComponent as IconArrow } from "assets/svg/16-arrowhead-left.svg";

import { getAccountInfoStart } from "../redux/accountInfo";

import { themesSelector } from "theme/selector";
import {
  accountInfoDataSelector,
  accountInfoStatusSelector,
} from "../redux/selector";

import { Avatar, Box, Typography } from "@mui/material";

// import { DIALOG } from "helper/enum/dialogEnum";

// import ModalChangeAvatar from "./ModalChangeAvatar";

import {
  AccountInfoWrapper,
  AvatarWrapper,
  InfoCode,
  InfoContainer,
  InfoName,
  NotiAmount,
  NotificationWrapper,
  NotiIconArrow,
} from "./style";
import SkeletonWrapper from "components/common/Skeleton";
import pxToRem from "theme/base/pxToRem";
import { motion } from "framer-motion";
import CustomPopover from "components/common/CustomPopover";
import NotificationPanel from "./Notification";
import {
  getListNotificationStart,
  resetListNotification,
} from "modules/Notification/redux/getListNoti";
import { getTotalNotificationDataSelector } from "modules/Notification/redux/selector";

const AccountInfo = () => {
  const dispatch = useDispatch();
  // const changeAvatarDialog = useDialog(DIALOG.CHANGE_AVATAR);
  const { isMiniSidenav } = useSelector(themesSelector);
  const { fullName, employeeCode, avatar } = useSelector(
    accountInfoDataSelector
  );

  const status = useSelector(accountInfoStatusSelector);
  const totalNewNoti = useSelector(getTotalNotificationDataSelector);

  useLegacyEffect(() => {
    dispatch(getAccountInfoStart());
    dispatch(
      getListNotificationStart({
        sort: "",
      })
    );
    return () => {
      dispatch(resetListNotification());
    };
  }, []);

  return (
    <AccountInfoWrapper>
      <InfoContainer isMiniSidenav={isMiniSidenav}>
        <SkeletonWrapper
          status={status}
          variant="circular"
          height={pxToRem(40)}
          width={pxToRem(40)}
        >
          <AvatarWrapper>
            <Avatar alt={fullName} src={avatar} />
            {/* <IconCamera className="camera-icon" /> */}
          </AvatarWrapper>
        </SkeletonWrapper>

        {!isMiniSidenav && (
          <motion.div
            key="nav-text"
            initial={{ opacity: 0, x: -10 }}
            animate={{ opacity: 1, x: 0, width: 0 }}
            exit={{ opacity: 0, x: -10 }}
            transition={{
              exit: { duration: 0.3, delay: 0.3 },
              animate: { duration: 0.1, delay: 0.3 },
            }}
            style={{ flex: 1 }}
          >
            <Box display="flex" flexDirection="column">
              <SkeletonWrapper
                variant="rectangular"
                status={status}
                height={pxToRem(18)}
              >
                <InfoCode
                  sx={{ whiteSpace: "nowrap" }}
                  color="lightpink"
                >{`Mã NV: ${employeeCode}`}</InfoCode>
              </SkeletonWrapper>
              <SkeletonWrapper
                variant="rectangular"
                status={status}
                height={pxToRem(24)}
              >
                <InfoName>{fullName}</InfoName>
              </SkeletonWrapper>
            </Box>
          </motion.div>
        )}
      </InfoContainer>
      <Box>
        <NotificationWrapper>
          <Box display={"flex"} alignItems={"center"} gap={1}>
            <IconBell />
            {!isMiniSidenav && (
              <>
                <Typography fontWeight={600} fontSize={14}>
                  Thông Báo
                </Typography>
                {totalNewNoti > 0 && <NotiAmount>+{totalNewNoti}</NotiAmount>}
              </>
            )}
          </Box>
          <NotiIconArrow>
            <IconArrow />
          </NotiIconArrow>
          <CustomPopover
            buttonLabel=""
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: 70,
              horizontal: -70,
            }}
            styleButton={{
              border: "none",
              backgroundColor: "transparent",
              position: "absolute",
              right: isMiniSidenav ? 20 : 50,
              maxWidth: "70%",
              ":hover": {
                outline: "none",
                border: "none",
                backgroundColor: "transparent",
              },
            }}
          >
            {({ onClose }) => <NotificationPanel onClose={onClose} />}
          </CustomPopover>
        </NotificationWrapper>
      </Box>
    </AccountInfoWrapper>
  );
};

export default AccountInfo;
